import { render, staticRenderFns } from "./GameConclude.vue?vue&type=template&id=0bb5c2e2&scoped=true&"
import script from "./GameConclude.vue?vue&type=script&lang=js&"
export * from "./GameConclude.vue?vue&type=script&lang=js&"
import style0 from "@vueform/slider/themes/default.css?vue&type=style&index=0&lang=css&"
import style1 from "./GameConclude.vue?vue&type=style&index=1&lang=css&"
import style2 from "./GameConclude.vue?vue&type=style&index=2&id=0bb5c2e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb5c2e2",
  null
  
)

export default component.exports